import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { SubtleLink } from '@liveauctioneers/hammer-ui-core/link';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { Component, ReactNode } from 'react';
import isEqual from 'react-fast-compare';

import noop from '@/utils/noop';

type Props = {
    className: string;
    hideSeeLess: boolean;
    itemsComponentFull: ReactNode[];
    itemsComponentShort: ReactNode[];
    itemsListLengthFull: number;
    itemsListLengthShort: number;
    linkClassName: string;
    onSeeLessItemsClick: Function;
    onSeeMoreItemsClick: Function;
    seeLessFormattedMessageId: string;
    seeMoreFormattedMessageId: string;
    showAllItems: boolean;
    showTotal: boolean;
};

type State = {
    seeMore: boolean;
};

export class SeeMoreItems extends Component<Props, State> {
    static defaultProps = {
        className: '',
        hideSeeLess: false,
        linkClassName: '',
        onSeeLessItemsClick: noop,
        onSeeMoreItemsClick: noop,
        seeLessFormattedMessageId: 'search_see_less',
        seeMoreFormattedMessageId: 'search_see_all',
        showAllItems: false,
        showTotal: false,
    };

    state = {
        seeMore: this.props.showAllItems,
    };

    shouldComponentUpdate = (nextProps: Props, nextState: State) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    onSeeLess = () => {
        this.changeSeeMore();
        this.props.onSeeLessItemsClick();
    };

    onSeeMore = () => {
        this.changeSeeMore();
        this.props.onSeeMoreItemsClick();
    };

    changeSeeMore = () => {
        const seeMore = !this.state.seeMore;
        this.setState({ seeMore });
    };

    render() {
        const { seeMore } = this.state;

        const {
            className,
            hideSeeLess,
            itemsComponentFull,
            itemsComponentShort,
            itemsListLengthFull,
            itemsListLengthShort,
            linkClassName,
            seeLessFormattedMessageId,
            seeMoreFormattedMessageId,
            showTotal,
        } = this.props;

        const showSeeMore = itemsListLengthFull > itemsListLengthShort && !seeMore;
        const showSeeLess = !showSeeMore && !hideSeeLess && itemsListLengthShort < itemsListLengthFull;

        return (
            <div className={className}>
                {seeMore ? itemsComponentFull : itemsComponentShort}
                {showSeeMore && (
                    <SubtleLink
                        className={cn('ml-xs', linkClassName)}
                        key="see-more"
                        onClick={this.onSeeMore}
                        size="sm"
                    >
                        <FormattedMessage id={seeMoreFormattedMessageId} />
                        {showTotal && <> ({itemsListLengthFull})</>}
                    </SubtleLink>
                )}
                {showSeeLess && (
                    <SubtleLink
                        className={cn('ml-xs', linkClassName)}
                        key="see-less"
                        onClick={this.onSeeLess}
                        size="sm"
                    >
                        <FormattedMessage id={seeLessFormattedMessageId} />
                    </SubtleLink>
                )}
            </div>
        );
    }
}
